import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaHome } from "react-icons/fa";

function ContactConfirmation() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToDashboard = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  return (
    <main
      className="page-content pb-5"
      aria-label={t("help.confirmation.aria")}
    >
      <div className="card shadow border-0 rounded-4 overflow-hidden text-center">
        <div className="card-header bg-project-gradient text-white border-0 py-4">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white bg-opacity-25 p-3 mb-2">
            <FaCheckCircle className="fs-2" aria-hidden />
          </div>
          <h3 className="mb-0 fw-bold">{t("help.confirmation.title")}</h3>
        </div>
        <div className="card-body bg-body-tertiary p-4">
          <div className="bg-white rounded-4 shadow-sm p-4">
            <p className="mb-2">{t("help.confirmation.body")}</p>
            <p className="text-muted small mb-4">
              {t("help.responseExpectation")}
            </p>
            <button
              type="button"
              className="btn btn-primary rounded-pill px-4 d-inline-flex align-items-center gap-2"
              onClick={handleGoToDashboard}
            >
              <FaHome aria-hidden />
              {t("help.confirmation.goDashboard")}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}

ContactConfirmation.displayName = "ContactConfirmation";

export default memo(ContactConfirmation);
